var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnRunDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-2 {\n        stroke: #FFFFFF;\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 64,
    height: 64
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 64,
    height: 64
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn_run_design"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.85,40.66c0-2.46-1.98-4.46-4.41-4.46s-4.41,2-4.41,4.46V15.1c0-2.05,1.34-3.9,3.31-4.38,2.92-.72,5.52,1.5,5.52,4.33v26.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.03,17.62h-26.96c-2.16,0-3.92,1.79-3.92,3.99v27.33c0-2.19,1.75-3.97,3.92-3.97h31.87c2.16,0,3.92-1.78,3.92-3.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.94,44.98v7.85c-2.55.51-4.79-1.43-4.79-3.88"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 19.28,
    cy: 37.1,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 27.62,
    cy: 37.1,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 35.96,
    cy: 37.1,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 19.28,
    cy: 25.1,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 27.62,
    cy: 25.1,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 35.96,
    cy: 25.1,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.28,35.1c0-2.2,1.79-4,4-4h8.68c2.2,0,4-1.79,4-4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 21.28,
    y1: 25.1,
    x2: 25.62,
    y2: 25.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 29.62,
    y1: 25.1,
    x2: 33.96,
    y2: 25.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 21.28,
    y1: 37.1,
    x2: 25.62,
    y2: 37.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 29.62,
    y1: 37.1,
    x2: 33.96,
    y2: 37.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.66,48.41h21.28l3.73,2.5-3.73,2.5h-21.28c-.55,0-1-.45-1-1v-3.01c0-.55.45-1,1-1ZM25.6,53.41v-5"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnRunDesign);
export default __webpack_public_path__ + "static/media/icn_run_design.e36e86a34495be2545875a8b94118b2d.svg";
export { ForwardRef as ReactComponent };